var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8346 16.625V15.0417C15.8346 14.2018 15.501 13.3964 14.9071 12.8025C14.3133 12.2086 13.5078 11.875 12.668 11.875H6.33464C5.49478 11.875 4.68933 12.2086 4.09546 12.8025C3.5016 13.3964 3.16797 14.2018 3.16797 15.0417V16.625",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4987 8.70833C11.2476 8.70833 12.6654 7.29057 12.6654 5.54167C12.6654 3.79276 11.2476 2.375 9.4987 2.375C7.7498 2.375 6.33203 3.79276 6.33203 5.54167C6.33203 7.29057 7.7498 8.70833 9.4987 8.70833Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser1);
export default __webpack_public_path__ + "static/media/user-1.094c21e88e214ffb9867991cc62b4482.svg";
export { ForwardRef as ReactComponent };